export enum Feature {
  Account,
  ViewBalance,
  BillingExplained,
  TransactionHistory,
  MonthlyStatements,
  PaymentMethods,
  AmountToPay,
  Landing,
  Dashboard,
  DashboardViewing,
  DashboardInternet,
  DashboardInsurance,
  DashboardInactive,
  DashboardSafety,
  Products,
  HolidayHome,
  Activate,
  AllProducts,
  Subscriptions,
  SubscriptionViewing,
  SubscriptionInactive,
  SubscriptionPending,
  SubscriptionLinkPackageSA,
  SelectManage,
  SelectViewing,
  LinkPackageQuoteBreakdown,
  BoxOffice,
  Insurance,
  Internet,
  Safety,
  Utils,
  FixError,
  Profile,
  ProfilePreferences,
  Offers,
  Rewards,
  Premium,
  Menu,
  Customer,
  Action,
  Inbox,
  WhatIsRewards,
  AvailableRewards,
  EarnMoreStars,
  Competitions,
  RewardsHistory,
  RentalHistory,
  RewardsPremiumStatus,
  RewardsWhatIsPremium,
  RecurringPayment,
}
